import { useSelector } from 'react-redux';
import { getLocationPayload } from '@/redux/location/selectors';
import NotFound from '@/pages/NotFound';
import { NarrativeCommunityProfile } from '@/pages/Narrative/components/NarrativeCommunityProfile';

export const NarrativeCommunityProfilePage = () => {
  const payload = useSelector(getLocationPayload);
  const { display_name: displayName } = (payload ?? {}) as Record<
    string,
    string | undefined
  >;

  if (!displayName) {
    return <NotFound />;
  }

  return <NarrativeCommunityProfile displayName={displayName} />;
};
